(function () {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  document.documentElement.classList.remove('no-js');

  const policyMenu = qs('[data-policy-menu]');
  const policyToggle = qs('[data-policy-toggle]');
  if (policyMenu && policyToggle) {
    policyToggle.addEventListener('click', () => {
      const open = policyMenu.classList.toggle('is-open');
      policyToggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (event) => {
      if (!policyMenu.contains(event.target)) {
        policyMenu.classList.remove('is-open');
        policyToggle.setAttribute('aria-expanded', 'false');
      }
    });
    policyMenu.addEventListener('mouseleave', () => {
      window.setTimeout(() => {
        if (!policyMenu.matches(':hover')) {
          policyMenu.classList.remove('is-open');
          policyToggle.setAttribute('aria-expanded', 'false');
        }
      }, 160);
    });
  }

  const mobileToggle = qs('[data-mobile-menu-toggle]');
  const mobileMenu = qs('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(open));
    });
  }

  const mobilePolicyToggle = qs('[data-mobile-policy-toggle]');
  const mobilePolicies = qs('[data-mobile-policies]');
  if (mobilePolicyToggle && mobilePolicies) {
    mobilePolicyToggle.addEventListener('click', () => {
      const open = mobilePolicies.classList.toggle('is-open');
      mobilePolicyToggle.setAttribute('aria-expanded', String(open));
    });
  }

  qsa('a[href^="#"], a[href^="/#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const hash = link.getAttribute('href').replace('/', '');
      const target = qs(hash);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  qsa('[data-faq-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.pb-faq-item');
      const answer = qs('.pb-faq-answer', item);
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      button.querySelector('b').textContent = open ? '+' : '-';
      if (answer) answer.hidden = open;
    });
  });

  qsa('[data-review-carousel]').forEach((carousel) => {
    const track = qs('[data-review-track]', carousel);
    const prev = qs('[data-review-prev]', carousel);
    const next = qs('[data-review-next]', carousel);
    const slideBy = () => Math.max(260, track.clientWidth / 3);
    if (prev && track) prev.addEventListener('click', () => track.scrollBy({ left: -slideBy(), behavior: 'smooth' }));
    if (next && track) next.addEventListener('click', () => track.scrollBy({ left: slideBy(), behavior: 'smooth' }));
  });

  qsa('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const page = button.closest('.pb-product-page');
      const main = page && qs('.pb-product-page__main-image img', page);
      if (!main) return;
      main.src = button.getAttribute('data-product-thumb');
      qsa('[data-product-thumb]', page).forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  qsa('[data-product-card-url]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, select, textarea')) return;
      const url = card.getAttribute('data-product-card-url');
      if (url) window.location.href = url;
    });
  });

  qsa('[data-variant-id]').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      const variantId = button.getAttribute('data-variant-id');
      const feedback = qs('[data-cart-feedback]');
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error('Unable to add item.');
        const cart = await fetch('/cart.js').then((res) => res.json());
        qsa('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        if (feedback) feedback.textContent = 'Added to cart.';
      } catch (error) {
        if (feedback) feedback.textContent = 'Please choose options on the product page.';
      } finally {
        button.disabled = false;
      }
    });
  });
})();
